














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class HeaderSearch extends Vue {

  private dataSource: string[] = ['选项一', '选项二'];
  private searchMode: boolean = false;

  private enterSearchMode() {
      this.searchMode = true;
      const input: any = this.$refs.input;
      setTimeout(() => input.focus(), 300);
    }
  private leaveSearchMode() {
      this.searchMode = false;
    }
}
